module.exports = __webpack_public_path__ + "media/video-thumbnails/1-25965df1.gif";